import { BrowserRouter, Routes, Route,  Link} from 'react-router-dom'
import Home from './pages/Home'
import Apropos from './pages/Apropos'
import Projets from './pages/Projets'
import PageNotFound from './pages/PageNotFound'
import Contact from './pages/Contact'
import Cat from './assets/catlogo.png'
//Theme Color Toggle
import{createContext, useState} from 'react';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
export const ThemeContext = createContext('null');
const  App = () =>{
  const [theme,setTheme] = useState('dark');
  const toggleTheme = () =>{
    setTheme((curr) => (curr === 'dark' ? 'light' : 'dark'));
  };
  return (
    <BrowserRouter>
    <ThemeContext.Provider value={{theme,toggleTheme}}>
    <div className="App" id={theme}>
     <nav>
      <div className='groupNav'>
            <div className='leftNav'>
            <Link to="/Contact">  <img className='catNav' src={Cat} alt='cat'/></Link>
                <ul>
                    <Link to="/"><li>RAPHAEL ALCANTARA</li></Link>
                    <div className='theme'>
                      <DarkModeSwitch onChange={toggleTheme} checked={theme === 'dark'}/>
                    </div>

                </ul>
            </div>               
                    <ul>
                        <Link to="/Projets"><li> MES PROJETS</li></Link>  
                        <Link to="/APropos"><li>A PROPOS</li></Link>
                        <Link to="/Contact"><li>CONTACT</li></Link>
                    </ul>
                    </div>
            </nav>
    
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/Projets" element={<Projets />} />
            <Route path="/Apropos" element={<Apropos />} />
            <Route path="/Contact" element={<Contact/>} />
            <Route path="*" element={<PageNotFound/>} />
          </Routes>
      
        </div>
        </ThemeContext.Provider>
     </BrowserRouter>

  );
}

export default App;
